var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.btnRequirementsMet)?_c('b-button',{staticClass:"w-100",attrs:{"id":"document-download","disabled":_vm.busy,"variant":"primary"},on:{"click":_vm.handleDownload}},[_vm._v(" Download een gegenereerd startdocument ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }